import { gql, useApolloClient } from '@apollo/client'
import { useEffect, useState } from 'react'

const GET_ORGS_PAGE = gql`
  query OrgsWithProjectsPage($cursor: Cursor) {
    orgList(limit: 100, cursor: $cursor) {
      pageInfo {
        endCursor
      }
      orgs {
        id
        displayName
        projectList {
          projects {
            id
            title
          }
        }
      }
    }
  }
`

export const useOrgsWithProjects = ({ skip } = {}) => {
  const client = useApolloClient()
  const [orgs, setOrgs] = useState([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (skip) return

    let cancelled = false

    const fetchAll = async () => {
      setLoading(true)
      setError(null)
      const accumulated = []
      let cursor = null

      try {
        while (true) {
          const { data, errors } = await client.query({
            query: GET_ORGS_PAGE,
            variables: { cursor },
            fetchPolicy: 'cache-first',
          })

          if (errors?.length) throw new Error(errors[0].message)

          const page = data?.orgList
          accumulated.push(...(page?.orgs || []))

          const nextCursor = page?.pageInfo?.endCursor
          if (!nextCursor) break
          cursor = nextCursor
        }
      } catch (e) {
        if (!cancelled) setError(e)
        return
      }

      if (!cancelled) {
        setOrgs(accumulated)
        setLoading(false)
      }
    }

    fetchAll()
    return () => {
      cancelled = true
    }
  }, [client, skip])

  return { orgs, loading, error }
}
